<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="banner-btm">
          <div class="text-center py-5 container">
            <h1 class="text-center mb-3 fw-bold" v-html="$t('Home.BannerTitle')"></h1>
            <p class="page-subheader mb-5" v-html="$t('Home.BannerDesc')"></p>

            <div class="readytosubmit mt-5">
              <h2 class="mb-4 fw-bold" v-html="$t('Home.ReadytoSubmitTitle')"></h2>
              <div class="row d-flex justify-content-center">
                <div class="col-sm-12 text-center">
                  <router-link :to="{ name: 'Enter' }" class="btn btn-link mb-4 px-5 py-2">
                    {{ $t('Home.GetStartedBtn') }}
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <small class="d-block mb-3" v-html="$t('Home.HavingTroubleLink')" @click="handleLinkClick"></small>
                  <small class="d-block" v-html="$t('Home.OfficialRulesLink')"></small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="how-to-blk">
          <div class="container">
            <h2 class="text-center mb-5 fw-bold">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <div class="row text-center d-flex justify-content-center">

              <div class="col-md-6 mb-4">
                <img src="https://snippcheck.blob.core.windows.net/files/Nestle_2008881_Purina_CA_Zukes/enter.png"
                  :alt="$t('Home.ShopTitle')" class="img-fluid mb-4" style="max-width: 60px;" />
                <h3 class="fw-bold mb-3">{{ $t('Home.ShopTitle') }}</h3>
                <p>
                  <span v-html="$t('Home.ShopDetail')"></span>
                </p>
              </div>

              <div class="col-md-6 mb-4">
                <img src="https://snippcheck.blob.core.windows.net/files/Nestle_2008881_Purina_CA_Zukes/win.png"
                  :alt="$t('Home.SnapTitle')" class="img-fluid mb-4" style="max-width: 60px;" />
                <h3 class="fw-bold mb-3">{{ $t('Home.SnapTitle') }}</h3>
                <p>
                  <span v-html="$t('Home.SnapDetail')"></span>
                </p>
              </div>

            </div>
          </div>
        </div>


      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    // New method: make <a> behave like router-links
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        // Only intercept internal links (those starting with '/')
        if (href && href.startsWith('/')) {
          event.preventDefault();
          const routeName = href.substring(1); // e.g. 'FAQ' from '/FAQ'

          if (routeName) {
            this.$router.push({ name: routeName }).catch(() => {
              // Fallback if route name doesn't exist
              this.$router.push(href);
            });
          }
        }
      }
    },
  }
};
</script>

<style scoped>
@media screen and (max-width: 575px) {}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
